import { useCohortDefinitionStore } from '@verantos-dev/app-state-cohort-definition';
import type { IndexDateCriterion } from '@verantos-dev/types-cohorts';

type Criterion = ReturnType<typeof useCohortDefinitionStore.getState>['criteria'][number];

const isIndexDateCriterion = (c: Criterion): c is IndexDateCriterion =>
  'criteriaType' in c && c.criteriaType === 'index_date';

export function getSourceLibraryAvIdFromCriterion(c: Criterion): string | null | undefined {
  if ('criteriaType' in c && c.criteriaType === 'analytical_variable' && 'sourceLibraryAvId' in c) {
    return (c as { sourceLibraryAvId: string | null | undefined }).sourceLibraryAvId;
  }
  if (isIndexDateCriterion(c) && c.value.type === 'Analytical variable') {
    return c.value.sourceLibraryAvId;
  }
  return undefined;
}

export function isCriterionSavedToLibrary(criteria: Criterion[], avId: string): boolean {
  const relevant = criteria.find(
    (c) =>
      ('analyticalVariableId' in c &&
        (c as { analyticalVariableId: string }).analyticalVariableId === avId) ||
      (isIndexDateCriterion(c) &&
        c.value.type === 'Analytical variable' &&
        c.value.analyticalVariableId === avId)
  );
  return relevant ? Boolean(getSourceLibraryAvIdFromCriterion(relevant)) : false;
}
